import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryConfig } from "store/baseQueryConfig ";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryConfig,
  tagTypes: ["invoices" , "quotes" /* autres tags */],
  endpoints: () => ({}),
});
